import { createWalletConfig } from "../../../wallet/utils/createWalletConfig.js";
import { ecosystemWalletId } from "../../../shared/constants/index.js";
import { client } from "../../../shared/utils/thirdweb.js";
import { inAppWalletConnector } from "@thirdweb-dev/wagmi-adapter";
/**
 * Creates a wagmi config with the B3 ecosystem wallet connector.
 * Delegates to createWalletConfig and adds the ecosystem connector on top.
 * @param options.partnerId - Partner ID for the ecosystem wallet
 * @param options.rpcUrls - Optional mapping of chain IDs to RPC URLs
 * @param options.connectors - Additional connectors to include
 * @param options.overrideDefaultConnectors - If true, only use provided connectors (ignores defaults)
 */
export function createWagmiConfig(options) {
    const { partnerId, rpcUrls, connectors = [], overrideDefaultConnectors = false } = options;
    const defaultConnectors = [
        inAppWalletConnector({
            ecosystemId: ecosystemWalletId,
            partnerId,
            client,
        }),
    ];
    const finalConnectors = overrideDefaultConnectors ? connectors : [...defaultConnectors, ...connectors];
    return createWalletConfig({
        connectors: finalConnectors,
        rpcUrls,
    });
}
